var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorldWideWeb2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 330.002 330.002",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.001,330.002c90.981,0,165-74.019,165-165C330.001,74.02,255.982,0,165.001,0s-165,74.02-165,165.002   C0.001,255.983,74.02,330.002,165.001,330.002z M57.423,246.464c13.074-5.142,29.535-9.24,48.037-12.048   c2.512,15.081,5.846,29.062,9.956,41.395c2.153,6.459,4.42,12.16,6.762,17.225C96.175,284.316,73.682,267.882,57.423,246.464z    M30.001,165.002c0-19.745,4.262-38.513,11.911-55.433c16.223,6.945,36.716,12.318,59.802,15.787   c-1.124,12.811-1.713,26.103-1.713,39.646c0,13.542,0.589,26.835,1.713,39.645c-23.086,3.47-43.58,8.843-59.801,15.788   C34.263,203.515,30.001,184.747,30.001,165.002z M165.001,30c3.23,0,12.644,8.231,21.126,33.678   c3.486,10.46,6.353,22.323,8.565,35.168c-9.643,0.674-19.587,1.03-29.695,1.03c-10.105,0-20.046-0.355-29.687-1.03   c2.212-12.845,5.079-24.707,8.566-35.167C152.358,38.231,161.771,30,165.001,30z M164.997,129.876   c11.427,0,22.629-0.42,33.479-1.221c1.002,11.705,1.525,23.891,1.525,36.347c0,12.456-0.523,24.64-1.524,36.345   c-10.85-0.801-22.05-1.221-33.476-1.221c-11.426,0-22.626,0.42-33.475,1.221c-1.002-11.705-1.525-23.89-1.525-36.345   c0-12.456,0.523-24.641,1.525-36.347C142.374,129.456,153.573,129.876,164.997,129.876z M300.001,165.002   c0,19.744-4.262,38.511-11.911,55.431c-16.223-6.945-36.716-12.317-59.802-15.786c1.124-12.81,1.713-26.102,1.713-39.645   c0-13.544-0.589-26.836-1.713-39.647c23.086-3.469,43.579-8.843,59.8-15.789C295.739,126.487,300.001,145.256,300.001,165.002z    M165.001,300.002c-3.23,0-12.643-8.232-21.124-33.678c-3.487-10.461-6.354-22.323-8.567-35.168   c9.643-0.675,19.584-1.03,29.691-1.03c10.107,0,20.049,0.355,29.691,1.03c-2.212,12.845-5.079,24.708-8.565,35.168   C177.645,291.771,168.232,300.002,165.001,300.002z M207.826,293.036c2.341-5.065,4.608-10.766,6.761-17.225   c4.111-12.333,7.445-26.314,9.957-41.395c18.5,2.808,34.961,6.905,48.035,12.047C256.321,267.88,233.829,284.315,207.826,293.036z    M272.577,83.537c-13.072,5.142-29.533,9.241-48.034,12.048c-2.512-15.08-5.845-29.062-9.956-41.394   c-2.152-6.459-4.42-12.16-6.762-17.226C233.827,45.687,256.319,62.12,272.577,83.537z M122.178,36.966   c-2.342,5.064-4.608,10.766-6.762,17.225c-4.11,12.334-7.444,26.315-9.956,41.396c-18.502-2.808-34.963-6.906-48.037-12.047   C73.681,62.122,96.174,45.686,122.178,36.966z",
    "data-original": "#000000",
    style: {}
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldWideWeb2);
export default __webpack_public_path__ + "static/media/world-wide-web-2.ad04cff33ab020ceb9f597d51e235773.svg";
export { ForwardRef as ReactComponent };